
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
props: {
headerIndex: {
type: Number,
default: 0
}
},
components: {
Tab,
TabItem
},
data () {
return {
currentCity: '',
activeIndex: 0
}
},
mounted () {
let localStorageObj = localStorage.getItem('iregional') ? JSON.parse(localStorage.getItem('iregional')) : {}
this.currentCity = localStorageObj.name || '全国'
},
watch: {
headerIndex: {
handler (newValue) {
this.activeIndex = newValue
},
immediate: true
}
},
methods: {

handleChangeCity () {
this.$router.push({
path: '/changeCity'
})
},
onItemClick (index) {
if (this.activeIndex === index) {
return
}
this.activeIndex = index
let path = ''
if (this.activeIndex === 0) {
path = '/home'
} else if (this.activeIndex === 1) {
path = '/cardList'
} else if (this.activeIndex === 2) {
path = '/infomation'
} else if (this.activeIndex === 3) {
path = '/plan'
}
this.$router.push({
path
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/header.vue